export default {
  currencySign: '$',
  state: "Estado",
  city: 'Ciudad',
}